export default __webpack_public_path__ + "static/media/FAQs-EN.61e8db05.jpg";